import React, { Component } from 'react';
import { ConsultCuentaAdmin } from "../../../funciones/EstCuentaFunction";

class EstIngresosTable extends Component {
    state = {
        boton1: {
            icon: "fa fa-money",
            text: "Cuenta",
            disabled: false
        },
    }

    verDetalles = (datos) => {
        if (this.state.boton1.disabled === true) return null;

        this.setState({
            boton1: {
                icon: "fa fa-spinner fa-spin",
                text: "Espera",
                disabled: true
            }
        }, () => {
            ConsultCuentaAdmin (datos.id, (resp)=> {
                this.props.Detalles([resp, datos])
                this.setState({
                    boton1: {
                        icon: "fa fa-money",
                        text: "Cuenta",
                        disabled: false
                    }
                })
            })
        })

    }

    render() { 
        let { datos } = this.props;
        let { boton1 } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        const styles2 = {
            padding: 5, fontSize: 11
        }

        let icono = () => {
            let text = "text-danger fa fa-times-circle"
            if (datos.Status === true) text = "text-success fa fa-check-circle";
            return text;
        }
        
        return (
            <React.Fragment>
                <tr>
                    <td style={styles}>{datos.Estudiante}</td>
                    <td align="center" style={styles2}>{datos.Carrera}</td>
                    <td align="center" style={styles}><i className={icono()}></i> {datos.Deuda}</td>
                    <td align="center" style={styles}>
                        <button className="btn btn-primary" onClick={()=> {this.verDetalles(datos)}} title= "Haz click aqui para ver el Estado de Cuenta" style={{borderWidth: 1}}><i className={boton1.icon}></i> {boton1.text}</button>
                    </td>
                </tr>
            </React.Fragment>
        );
    }
}
 
export default EstIngresosTable;


// WEBPACK FOOTER //
// ./src/views/Administracion/IngresosContent/EstIngresosTable.jsx